import { useRef } from "react";
import { GlobalConfiguration } from "../utils/configurationProvider";
const UseHandleScroll = (
  setDirection,
  lastScrollTop,
  height = GlobalConfiguration.scrollPixel,
) => {
  const handleScroll = (e) => {
    const currentScrollTop = e?.target?.scrollTop;
    if (currentScrollTop > lastScrollTop.current && currentScrollTop > height) {
      setDirection("down");
    } else if (
      currentScrollTop + height < lastScrollTop.current ||
      currentScrollTop === 0 ||
      lastScrollTop.current === 0
    ) {
      setDirection("up");
    }

    lastScrollTop.current = currentScrollTop;
  };

  return { handleScroll };
};

export default UseHandleScroll;